import React from 'react';
import { useNavigate } from 'react-router-dom';

import { TJobRenderComponentProps } from '@/console/features/jobs/components/jobs-list/jobs-list-renderer.types';
import { TextButton } from '@/shared/components/ui/button/text-button/text-button';
import { useVendor } from '@/shared/hooks/use-vendor/use-vendor';
import { useReadDeviceQuery } from '@/shared/redux/api/assets/devices/devices-api';
import { useReadProjectsByIdsQuery } from '@/shared/redux/api/assets/projects/projects-api';
import { FeatureTypeEnum } from '@/shared/types/types.generated';
import { formatVersionId } from '@/shared/utils/format';

export const JobProjectVersion: React.FC<TJobRenderComponentProps> = ({
  job,
  versionIndex = 0,
}) => {
  const navigate = useNavigate();
  const deviceId = job?.deviceIds?.[0];
  const { data: deviceData } = useReadDeviceQuery(
    { deviceId: deviceId! },
    { skip: !deviceId },
  );
  const device = deviceData?.readDevice;
  const { getFeatureType } = useVendor();
  const isDeviceJob =
    !!device &&
    !!job?.jobType &&
    getFeatureType({ feature: job.jobType, ...device }) ===
      FeatureTypeEnum.DeviceFeature;

  const { data: projectsData } = useReadProjectsByIdsQuery(
    { projectIds: job?.projectIds! },
    { skip: !job?.projectIds?.length || isDeviceJob },
  );

  const project = projectsData?.readProjectsByIds?.items?.[0];
  const versionId = job?.projectVersionIds?.[versionIndex];

  if (!versionId || isDeviceJob) {
    return null;
  }

  return (
    <TextButton
      variant="primaryLighter"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/projects/${project?.projectId}/versions`);
      }}
      tooltip={versionId}
      disabled={!project}
    >
      {formatVersionId({ versionId })}
    </TextButton>
  );
};
